var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_c('textloader-component',{attrs:{"textKey":"FrejaRubrik"}})],1),_c('paragraph-component',[_c('textloader-component',{attrs:{"textKey":"FrejaBrödtext"}})],1),_c('v-img',{staticClass:"center",attrs:{"src":require('@/assets/Information/Futf/Freja.jpg'),"max-width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }